import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAddressLists } from "../../../../Store/Action/addressAction";
import Icons from "../../../../Config/Images";
import { Switch } from "@mui/material";
import styles from "./styles";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const SelectAddressComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [billingAddress, setBillingAddress] = useState({});
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [isSameAsBilling, setIsSameAsBilling] = useState(true); // Default: shipping address hidden
  const selectedShippingData = location.state?.selectedShippingData;

  useEffect(() => {
    dispatch(
      getAddressLists({}, (result) => {
        setBillingAddress(result?.data?.billing_address || {});
        setShippingAddresses(result?.data?.shipping_address || []);
      })
    );
  }, [dispatch]);

  const handleSwitchChange = (event) => {
    setIsSameAsBilling(event.target.checked);
  };

  const handleAddress = (action) => {
    // Handle address addition logic here
    navigate("/my-account/my-address");
  };

  const onEditIcon = (type, address) => {
    navigate(`/my-account/edit-address`, {
      state: { addressType: 2, addressData: address, isSelectAddress: true },
    });
  };

  // Determine shipping data to display
  const displayShippingAddresses =
    selectedShippingData && Object.keys(selectedShippingData).length > 0
      ? [selectedShippingData] // Wrap selectedShippingData into an array for consistency
      : shippingAddresses?.slice(0, 1);

  return (
    <div style={styles.mainContainer}>
      <p style={styles.title}>Select Address</p>

      <div style={styles.addressSection}>
        {/* Billing Address */}
        {billingAddress?.user_first_name ? (
          <div style={styles.billingAddress}>
            <p style={styles.sectionTitle}>Billing Address</p>
            <div style={styles.addressCard}>
              <div style={styles.addressDetails}>
                <p style={styles.blackTextStyle}>
                  {`${billingAddress?.user_first_name} ${billingAddress?.user_last_name}`}
                </p>
                <p style={styles.blackTextStyle}>
                  {[
                    billingAddress?.user_address_1,
                    billingAddress?.user_address_2,
                    billingAddress?.city,
                    billingAddress?.state,
                    billingAddress?.zip_code,
                  ]
                    ?.filter(Boolean)
                    .join(", ")}
                </p>
                <p style={styles.blackTextStyle}>
                  <span style={styles.mobileNoText}>Mobile No:</span>{" "}
                  {billingAddress?.user_mobile_number}
                </p>
              </div>
              <img
                src={Icons.edit_icon}
                style={styles.editIcon}
                alt="Edit"
                onClick={() => onEditIcon("billing", billingAddress)}
              />
            </div>

            <div style={styles.textWithSwitch}>
              <p style={styles.switchTextStyle}>
                Shipping Address is Same As Per Above?
              </p>
              <Switch
                className="switch-btns"
                checked={isSameAsBilling}
                onChange={handleSwitchChange}
                inputProps={{ "aria-label": "controlled" }}
                sx={{
                  "& .MuiSwitch-track": {
                    background:
                      "linear-gradient(180deg, #E8EAEA 0%, #FFFFFF 100%)", // Light gradient for unchecked state
                    opacity: 1,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    background:
                      "linear-gradient(180deg, #B88A35 0%, #855E2A 100%)", // Golden gradient for checked state
                    opacity: 1,
                  },
                  "& .MuiSwitch-thumb": {
                    background:
                      "linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%)", // Light gradient for thumb in unchecked state
                  },
                  "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
                    background: "#FFFFFF", // Solid white for thumb when checked
                  },
                }}
              />
            </div>
          </div>
        ) : (
          // If billingAddress is null, show the "Add Address" section
          <div style={styles.addressView} onClick={() => handleAddress("add")}>
            <img
              src={Icons.plus_vector_icon}
              alt="Add Address"
              style={styles.plusIcon}
            />
            <p style={styles.addAddressText}>Add Address</p>
          </div>
        )}

        {/* Shipping Addresses */}
        {!isSameAsBilling && ( // Show shipping address only if the switch is off
          <div style={styles.shippingAddress}>
            <p style={styles.sectionTitle}>Shipping Address</p>
            {displayShippingAddresses?.map((address, index) => (
              <div style={styles.addressCard} key={index}>
                <div style={styles.addressDetails}>
                  <p style={styles.blackTextStyle}>
                    {`${address?.user_first_name} ${address?.user_last_name}`}
                  </p>
                  <p style={styles.blackTextStyle}>
                    {[
                      address?.user_address_1,
                      address?.user_address_2,
                      address?.city,
                      address?.state,
                      address?.zip_code,
                    ]
                      ?.filter(Boolean)
                      .join(", ")}
                  </p>
                  <p style={styles.blackTextStyle}>
                    <span style={styles.mobileNoText}>Mobile No:</span>{" "}
                    {address?.user_mobile_number}
                  </p>
                </div>
                <img
                  src={Icons.edit_icon}
                  style={styles.editIcon}
                  alt="Edit"
                  onClick={() => onEditIcon("shipping", address)}
                />
              </div>
            ))}
            <button
              style={styles.changeAddressButton}
              onClick={() => handleAddress("change")}
            >
              Change Shipping Address
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectAddressComponent;
